define.alias("shared/utils/object-methods/object-map", "calendar/utils/object-methods/object-map");